<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-ticket-detail">
    <header class="ren-decoration-cp-scenic-ticket-detail__head">
      <strong>{{ title }}</strong>
    </header>
    <div class="ren-decoration-cp-scenic-ticket-detail__body" v-html="html"></div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '团购详情'))
const html = computed(() => {
  const override = stringValue(props.component.props?.html)
  return override ||
    '<p>本票支持随买随用，无需换票，凭订单二维码直接入园。</p>' +
    '<p>费用含景区大门票，请按选定日期与场次使用。</p>'
})
</script>

<style scoped>
.ren-decoration-cp-scenic-ticket-detail {
  display: grid;
  gap: 8px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-ticket-detail__head strong {
  color: var(--ren-theme-text);
  font-size: 14px;
}
.ren-decoration-cp-scenic-ticket-detail__body {
  color: var(--ren-theme-muted);
  font-size: 12px;
  line-height: 1.7;
}
.ren-decoration-cp-scenic-ticket-detail__body :deep(p) {
  margin: 0 0 6px;
}
</style>
